import React from 'react';

const Accounts = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h2>Accounts</h2>
      <p>Welcome to the Accounts page.</p>
    </div>
  );
};

export default Accounts;
